export let LayoutType;
(function (LayoutType) {
  LayoutType["CentredStep"] = "CentredStep";
  LayoutType["FramedCentredModalStep"] = "FramedCentredModalStep";
  LayoutType["TwoColumn"] = "TwoColumn";
  LayoutType["LeftAlignedTwoColumn"] = "LeftAlignedTwoColumn";
  LayoutType["LeftAligned"] = "LeftAligned";
  LayoutType["SidePanel"] = "SidePanel";
})(LayoutType || (LayoutType = {}));
export let DecorativeBgComponent;
(function (DecorativeBgComponent) {
  DecorativeBgComponent["Circles"] = "Circles";
  DecorativeBgComponent["CirclesWithStars"] = "CirclesWithStars";
})(DecorativeBgComponent || (DecorativeBgComponent = {}));